/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setReportProperties } from 'state/actions/reportsState/selected_report_status';
// component
import ReportSettings from 'pages/dashboard/reports/detail/settings/settings';



/* ========== ~~~~~~~~~~ REPORT SETTINGS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ reportsState }) => ({
    name: reportsState.selectedReportStatus.selectedReportData.name, 
    valid: reportsState.selectedReportStatus.selectedReportData.selectedReportDataValid,
    dateRange: reportsState.selectedReportStatus.selectedReportData.dateRange,
    customDateRange: reportsState.selectedReportStatus.selectedReportData.customDateRange,
});

// map actions

const mapDispatchToProps = dispatch => ({
    setReportProperties: properties => dispatch(setReportProperties(properties))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportSettings);
